import type { ReactElement } from "react";

import { StyledLeadsPageRoot } from "app/pages/sales-intelligence/common-components/layout";
import { useIsLeadsCriticalDataLoading } from "app/pages/sales-intelligence/modules/leads-search/hooks/useIsLeadsCriticalDataLoading";
import { SidebarContainer, SidebarTrackingSectionName } from "app/pages/sales-intelligence/sub-modules/right-sidebar";

import { useCrmListSavedSearch } from "../../hooks/useCrmListSavedSearch";
import CrmListPageHeaderContainer from "../PageHeader/CrmListPageHeaderContainer";
import PageMainContent from "../PageMainContent/PageMainContent";

const CrmListContent = (): ReactElement => {
    useCrmListSavedSearch();

    const isLeadsCriticalDataLoading = useIsLeadsCriticalDataLoading();

    return (
        <StyledLeadsPageRoot>
            <CrmListPageHeaderContainer />
            <PageMainContent />

            {isLeadsCriticalDataLoading ? null : (
                <SidebarContainer trackingSectionName={SidebarTrackingSectionName.List} />
            )}
        </StyledLeadsPageRoot>
    );
};

export default CrmListContent;
